export default function AppSection() {
  const handleImgError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    img.style.display = 'none';
    const container = img.closest('.img-wrap') as HTMLElement | null;
    if (container) container.style.display = 'none';
  };

  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-primary-500 rounded-3xl p-10 md:p-14 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-[300px] h-[300px] bg-white/5 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3"></div>
          <div className="absolute bottom-0 left-0 w-[250px] h-[250px] bg-white/5 rounded-full blur-3xl -translate-x-1/3 translate-y-1/3"></div>

          <div className="flex-1 relative z-10 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
              随时随地 · 畅享观影
            </h2>
            <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-6">
              八戒影视全面适配手机、平板和电脑端，无论在家还是出行途中，
              打开浏览器即可享受高清流畅的观影体验。无需下载APP，无需占用存储空间，
              网页端直接播放，省心又省力。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 text-background-50 text-sm whitespace-nowrap">
                <i className="ri-smartphone-line"></i> 手机端适配
              </span>
              <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 text-background-50 text-sm whitespace-nowrap">
                <i className="ri-tablet-line"></i> 平板端适配
              </span>
              <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 text-background-50 text-sm whitespace-nowrap">
                <i className="ri-computer-line"></i> 电脑端适配
              </span>
            </div>
          </div>

          <div className="img-wrap flex-shrink-0 relative z-10 w-[240px] aspect-[5/8]">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20movie%20streaming%20interface%20with%20warm%20cinematic%20theme%2C%20floating%20on%20clean%20background%2C%20elegant%20UI%20design%2C%20golden%20accent%20colors%2C%20minimal%20product%20photography%2C%20soft%20lighting%2C%20premium%20device%20presentation&width=500&height=800&seq=app-bajie-01&orientation=portrait"
              alt="八戒影视移动端观影体验"
              className="w-full h-full object-contain"
              width="500"
              height="800"
              onError={handleImgError}
            />
          </div>
        </div>
      </div>
    </section>
  );
}